import { go, html, strMap } from 'fxjs/es';
import { NessLabsTmplS } from './module/NessLabsTmplS.js';
import {
  nessPlusProductListFetchLimit,
  NessProductListType,
} from '../../../Ness/App/Plus/Product/S/Constant/product.js';
import {
  categoryListTmpl,
  emptyProductListTmpl,
  filterTmpl,
} from '../../../Ness/App/Plus/Product/S/Tmpl/product.js';
import { UtilS } from '../../../Util/S/Function/module/UtilS.js';

export const labsContentContainer = ({
  products,
  total_page = Infinity,
  current_page = 1,
  limit = nessPlusProductListFetchLimit.labs,
  offset = 0,
  page_length = 10,
}) => {
  return html`
    <div class="labs__content-container">
      <div class="maple-labs-product-list">${strMap(NessLabsTmplS.makeProductItem, products)}</div>
      ${UtilS.htmlIf(
        products.length,
        NessLabsTmplS.makePagination({
          total_page,
          current_page,
          limit,
          page_length,
          hide_edges: true,
        }),
      )}
    </div>
  `;
};

export const makeLabsHtml = (
  {
    cate_lists,
    only_limited,
    is_not_sold_out,
    products,
    cate_list_id,
    cate_item_id,
    sort_options,
    selected_sort_option,
    is_mobile,
    labs_data = {},
    pagination_state = {},
    is_login,
    labs_product_cate_lists,
  },
  domain_name,
) => {
  const component = 'ness-plus-product-list';
  const product_list_type = NessProductListType.labs;
  const is_custom_store = false;

  return html`
    <div
      class="${component}"
      data-type="${product_list_type}"
      data-domain_name="${domain_name}"
      data-is_asset_store="${is_custom_store}"
      data-custom_level="${labs_data.custom_level}"
      data-show-products="${labs_data.characters.length > 0 && !labs_data.characters.error}"
    >
      <div class="${component}__features">
        <div class="${component}__cate-lists" data-is_asset="${is_custom_store}">
          ${categoryListTmpl(product_list_type, cate_lists, cate_list_id, is_custom_store)}
        </div>
        <div class="${component}__filters">
          ${filterTmpl(
            product_list_type,
            cate_lists,
            cate_list_id,
            cate_item_id,
            only_limited,
            is_not_sold_out,
            sort_options,
            selected_sort_option,
            is_mobile,
            is_custom_store,
          )}
        </div>
      </div>
      ${makeLabsMainTmpl({
        characters: labs_data.characters,
        is_login,
        is_mobile,
        products,
        pagination_state,
        labs_product_cate_lists,
      })}

      <div class="${component}__products--empty" data-show="${products.length === 0}">
        ${emptyProductListTmpl()}
      </div>
    </div>
  `;
};

export const makeLabsMainTmpl = ({
  characters,
  is_login,
  is_mobile,
  products,
  pagination_state,
  labs_product_cate_lists,
}) => {
  return html` <div class="ness-plus-product-list__products" data-show="${products.length > 0}">
    ${NessLabsTmplS.labsMainContainer({ characters, is_login, is_mobile })}
    ${UtilS.htmlIf(
      is_login,
      html` <div class="ness-plus-product-list__labs-category">
        <ul class="labs__category">
          ${go(
            labs_product_cate_lists,
            strMap(({ id, name, selected }) => {
              const selected_class = selected ? 'selected' : '';
              return html`
                <li class="labs__category__item ${selected_class} category" data-id="${id}">
                  <span class="labs__category__cate_list_name">${name}</span>
                </li>
              `;
            }),
          )}
        </ul>
      </div>`,
    )}
    ${UtilS.htmlIf(
      is_login && characters.length > 0,
      NessLabsTmplS.labsContentContainer({
        labs_product_cate_lists,
        products,
        ...pagination_state,
      }),
    )}
  </div>`;
};
